module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-Regular.woff?14d1275c67676cc5d911232d0c890d97";